<template>
  <div class="devices">
    <ul class="devices__list">
      <template v-if="combinedMeters.length > 0">
        <li v-for="(meter, index) in combinedMeters" :key="meter.name || index" class="devices__list-item">
          <template v-if="!meter.showlink">
            <MeterTeaser :meter="meter" />
          </template>
          <template v-else>
            <router-link :to="{
                name: 'meter-detail',
                params: {
                  meterid:
                    (meter.inverterSettings &&
                      (meter.inverterSettings.inverterid ||
                        meter.inverterSettings.inverterHost)) ||
                    (meter.settings && meter.settings.inverterHost) ||
                    1,
                },
              }">
              <MeterTeaser :meter="meter" />
            </router-link>
          </template>
        </li>
      </template>
    </ul>
  </div>
</template>

<style lang="scss" scoped></style>


<script>
import MeterTeaser from '@/components/meters/MeterTeaser.vue';
import { useAppStore } from '@/stores/useAppStore';
import { computed, defineComponent } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({
  name: 'meterTeaser',
  components: {
    MeterTeaser,
  },
  props: {
    devices: {
      type: Array,
    },
    teaser: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup(props) {
    const appStore = useAppStore()
    const router = useRouter()

    const customerInfo = computed(() => appStore.customerInfo || {})
    const meterType = computed(() => customerInfo.value.meterType)

    const combinedMeters = computed(() => {
      const simplifiedMeterTypes = [
        'Shelly Pro 3EM MQTT',
        'Meterless',
        'eFriends Meter (Firmware V1-V4)',
        'GridOp SmartMeter',
      ]

      if (simplifiedMeterTypes.includes(meterType.value)) {
        return [
          {
            name:
              meterType.value === 'Meterless'
                ? 'keine Echtzeitmessung'
                : meterType.value,
            manufacturer:
              meterType.value === 'Meterless'
                ? 'Meterless'
                : ['eFriends Meter (Firmware V1-V4)'].includes(meterType.value)
                ? meterType.value
                : 'custom',
            showlink: false,
          },
        ]
      }

      let thirdPartyMeterConfig = []
      let inverterSettings = []

      try {
        const parsed = JSON.parse(customerInfo.value.thirdPartyMeterConfig || '[]')
        if (Array.isArray(parsed)) {
          thirdPartyMeterConfig = parsed.map((obj) => ({
            ...obj,
            showlink: true,
          }))
        } else if (parsed && typeof parsed === 'object') {
          parsed.showlink = true
          thirdPartyMeterConfig = parsed
        }
      } catch (e) {
        console.error('Failed to parse thirdPartyMeterConfig:', e)
      }

      if (meterType.value === 'MODBUS Siemens PAC3200') {
        const manufacturerName = thirdPartyMeterConfig?.deviceMetadata?.manufacturer || 'Unbekannt';
        const manufacturer = manufacturerName == "Victron"
            ? "victron"
            : "custom";
        
        thirdPartyMeterConfig = [
          {
            ...thirdPartyMeterConfig,
            name: manufacturerName,
            manufacturer: manufacturer,
            showlink: true,
          },
        ]
      }

      try {
        inverterSettings = JSON.parse(customerInfo.value.inverterSettings || '[]').map(
          (obj) => ({
            ...obj,
            showlink: true,
          })
        )
      } catch (e) {
        console.error('Failed to parse inverterSettings:', e)
      }

      if (Array.isArray(thirdPartyMeterConfig) && Array.isArray(inverterSettings)) {
        return [...thirdPartyMeterConfig, ...inverterSettings]
      } else if (Array.isArray(thirdPartyMeterConfig)) {
        return thirdPartyMeterConfig
      } else if (Array.isArray(inverterSettings)) {
        return inverterSettings
      } else {
        return []
      }
    })

    const phoneUrl = computed(() => `tel:${appStore.contactData.phone}`)
    const phoneFormatted = computed(() => appStore.contactData.phoneFormatted)
    const emailUrl = computed(() => `mailto:${appStore.contactData.email}`)

    function toShop() {
      router.push({ name: 'shop' })
    }

    return {
      combinedMeters,
      phoneUrl,
      phoneFormatted,
      emailUrl,
      customerInfo,
      toShop,
    }
  },
})
</script>

<style lang="scss">
  .devices {
    margin-top: 0 !important;

    &__list {
      list-style: none;
      margin: 0;
      padding: 0;

      &-item {

        &:hover,
        &:focus,
        &:active {
          background: rgba(0, 0, 0, 0.03);
        }
      }
    }
  }

  .spacer {
    height: 5rem;
  }

  @media (max-width: 630px) {
    .spacer {
      height: 1rem;
    }
  }

  .mt {
    margin-top: 1rem;
  }
</style>